import React, { FC } from 'react';
import styled from 'styled-components';

interface SelectionProps {
    tip?: React.ReactElement<any>;
    label: string;
    icon: React.ReactElement<any>;
    onClick?: () => void;
    children?: React.ReactNode;
    isPod?: boolean;
    disabled?: boolean;
}
const ImageContainer = styled.div<{ $isPod?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 72px;

    svg,
    img {
        width: auto;
        height: 68px;
        max-width: 160px;
        object-fit: contain;
    }
`;

const SelectionLabel = styled.div<{ disabled?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    color: ${(props) => props.theme.app.component.card.title.color};
    gap: 6px;
    margin-top: 12px;

    ${(props) =>
        props.disabled &&
        `
			color: rgb(143, 164, 175);
	`}
`;

const SelectionCaption = styled.div`
    font-size: 12px;
    font-weight: 400;
    color: #666;
    text-align: center;
    line-height: 1.4;
`;

const SelectionContainer = styled.div<{ $isPod?: boolean; disabled?: boolean }>`
    display: flex;
    flex-direction: column;
    min-height: 160px;
    width: 100%;
    height: 100%;
    position: relative;
    border-radius: 8px;
    background: #ffffff;
    border: 1px solid #dbe2e6;
    padding: 16px;
    ${(props) => (props.$isPod ? 'justify-content: center;' : '')}

    ${(props) =>
        props.disabled &&
        `
			background: #ffffff;
			border: 1px solid #dbe2e6;
			color: rgb(143, 164, 175);
	`}

	${(props) =>
        !props.disabled &&
        `
	&:hover {
		cursor: pointer;
		border-color: ${props.theme.app.secondary};
		box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
	}
	`}
`;

export const SelectionType: FC<SelectionProps> = (props) => {
    return (
        <SelectionContainer $isPod={props.isPod} onClick={props.onClick} disabled={props.disabled}>
            <ImageContainer $isPod={props.isPod}>{props.icon}</ImageContainer>

            {props.label && (
                <SelectionLabel disabled={props.disabled}>
                    {props.label}
                    {props.tip && <SelectionCaption>{props.tip}</SelectionCaption>}
                </SelectionLabel>
            )}
        </SelectionContainer>
    );
};

const SelectionTypeContainerContent = styled.div`
    display: grid;
    grid-gap: 30px;
    justify-content: center;
    align-items: center;
    margin: auto;
    padding-top: 20px;
    grid-template-columns: repeat(auto-fit, 330px);
    @media screen and (max-width: 1910px) {
        grid-template-columns: repeat(2, 330px);
    }
`;

export const SelectionTypeContainer = ({ children }: { children: React.ReactNode }) => {
    return <SelectionTypeContainerContent>{children}</SelectionTypeContainerContent>;
};
